export const TWO_COLUMN_BREAKPOINT = 1000;
export const SMALL_MOBILE_BREAKPOINT = 320;
export const PADDING_BASE = 40;
